module.exports = __webpack_public_path__ + "static/media/logo-astronaut.2aefa988.svg";